<template>
	<!-- 查看弹窗 -->
	<div v-if="viewData&&viewData.isShow">
	    <div class="mask check-log" v-if="!isDetailsShow">
	        <div class="e-modal medium">
	            <div class="e-modal-title">View <i class="e-modal-close" @click="viewData.isShow=false"></i></div>
	            <div class="e-modal-body details-wt-table">
	                <table class="check-log-table" cellspacing="0">
	                    <tr>
	                        <td>SN</td>
	                        <td>Purchase order</td>
	                        <td>Bank</td>
	                        <td>Card</td>
	                        <td>Price</td>
	                        <td>Date</td>
	                    </tr>
	                    <tbody  v-for="(item,index) in list">
	                   	<tr>
	                    	<td>{{index+1}}</td>
	                        <td>{{item.OrderNO}}</td>
	                        <td>{{item.SupBankName}}</td>
	                        <td>{{item.SupBankAccount}}</td>
	                        <td>{{item.Amount}}</td>
	                        <td>{{item.Date|dateLong}}</td>
	                    </tr>
	                    <tr>
	                    	<td colspan="6">
	                    		<img :src="item.EevidenceImg">
	                    	</td>
	                    </tr>
	                    <tr>
	                    	<td colspan="6">
	                    		<div class="review-details-btn" @click="showDetails(item)">
	                    			View payment details
	                    		</div>
	                    	</td>
	                    </tr>
	                    </tbody>
	                    <tr v-if="!list||list.length<=0">
	                    	<td colspan="7">No relevant data</td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>


	    <div class="mask check-log" v-if="isDetailsShow">
	        <div class="e-modal medium">
	            <div class="e-modal-title">Payment details <i class="e-modal-close" @click="isDetailsShow=false"></i></div>
	            <div class="e-modal-body details-wt-table">
	                <table class="check-log-table " cellspacing="0">
	                    <tr>
	                        <td>Purchase order</td>
	                        <td>Hotel</td>
	                        <td>Guest</td>
	                        <td>Bank/Card</td>
	                        <td>Price</td>
	                        <td>Date</td>
	                    </tr>
	                    <tbody  v-for="(item,index) in detailsList">
	                   	<tr>
	                    	
	                        <td>{{item.OrderNO}}</td>
	                        <td>{{item.SupName}}</td>
	                        <td>{{item.Guests}}</td>
	                        <td>
	                        	{{item.SupBankName}}</br>
	                        	{{item.SupBankAccount}}
	                    	</td>
	                        <td>{{item.Amount}}</td>
	                        <td>{{item.Date|dateLong}}</td>

	                    </tr>
	             
	                    </tbody>

	                    <tr v-if="!detailsList||detailsList.length<=0">
	                    	<td colspan="7">No relevant data</td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>



    </div>
</template>
<script>
export default {
	name: 'paymentView',
	props:{
        vdata: {
            type: Object,
 			default: function(){
                return {}
            }
        }
  	},
  	data(){
  		return {
  			viewData:{},
  			list:[],
  			detailsList:[],
  			isDetailsShow:false
  		}
  	},
  	watch:{
  		vdata(val){
  			this.viewData=val;
  			this.initData();
  		}
  	},
  	methods:{

  		showDetails(item){
			
			var that=this;
			that.isDetailsShow=true;
	        var params={
	          paymentid: item.PaymentID
	        }
	        that.getRequest({
	            url: that.Api.getPaymentsByPaymentID,
	            params: params
	        }).then(res => {
	        	
	        	if(res&&res.Result.length>0){
	        		this.detailsList = res.Result;
	        	}else{
	        		this.detailsList = [];
	        	}
	        });
			
  		},
  		initData(){
  			var that=this;
	        var params={
	          supOrderNO: that.viewData.MainOrderId
	        }
	        that.getRequest({
	            url: that.Api.getPaymentsByOrderNO,
	            params: params
	        }).then(res => {
	        	if(res&&res.Result.length>0){
	        		that.list=res.Result;
	        	}else{
	        		// that.error({ title: '提示', content: '没有查询到相关数据' });
	        	}
	        });
  		}

  	}


}
</script>


// WEBPACK FOOTER //
// src/components/payment/paymentView.vue